import { render } from "./MailingMessagesdetail.vue?vue&type=template&id=7b1aefa1"
import script from "./MailingMessagesdetail.vue?vue&type=script&lang=js"
export * from "./MailingMessagesdetail.vue?vue&type=script&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "E:\\My project backups\\my project backups\\vuestyle3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__